.label {
  color: light-dark(var(--mantine-color-dimmed), var(--mantine-color-gray-4));
}
